import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { getAppInitQueryKey } from 'src/hooks/useAppInit';
import { getLinkedStatusAtSessionStart } from 'src/utils/getLinkedStatus';
import { getMarketplace } from 'src/utils/marketplace';
/**
 * Returns common API params for all requests.
 */
export const useDefaultApiParams = () => {
    const [searchParams] = useSearchParams();
    const queryClient = useQueryClient();
    const getDefaultParams = useCallback(() => {
        const marketplaceId = getMarketplace(searchParams);
        const appData = queryClient.getQueryData(getAppInitQueryKey(marketplaceId));
        const linkedAtSessionStart = getLinkedStatusAtSessionStart(searchParams, appData === null || appData === void 0 ? void 0 : appData.linked);
        if (!appData || !appData.joinId || !appData.csrfToken) {
            throw new Error('App init data not loaded');
        }
        return {
            marketplaceId,
            xUserLinked: linkedAtSessionStart,
            xJoinId: appData.joinId,
            antiCsrftokenA2z: appData.csrfToken,
        };
    }, [searchParams]);
    return { getDefaultParams };
};
